import { TranslationKeys as CoreTranslations } from '@pascal/pascal-core';

const TranslationKeys = {
  CHACK_HASH_CODE: 'CHACK_HASH_CODE',
  ABOUT_HASH_CODE: 'ABOUT_HASH_CODE',
  ROUND_HASH_CODE: 'PROVABLY_FAIRNESS',
  CHECK: 'CHECK',
  RoundId: 'ROUND_ID',
  HASH_CODE: 'HASH_CODE',
  FAIRNESS_MODAL_TITLE: 'PROVABLY_FAIRNESS',
  HELP: 'HELP',
  Info: 'INFO',
  LOBBY: 'LOBBY',
  BETS: 'BETS',
  STATISTICS: 'STATISTIC',
  RESULTS: 'RESULTS',
  OK: 'OK',
  PleaseWait: 'PLEASE_WAIT',
  CONNECTING: 'CONNECTING',
  AutoBet: 'AUTO_BET',
  BetsAreClosing: 'BETS_ARE_CLOSING',
  PlaceYourBets: 'PLACE_YOUR_BETS',
  BetsAreClosed: 'BETS_ARE_CLOSED',
  YouWin: 'YOU_WIN',
  provablyFairness: 'PROVABLY_FAIRNESS',
  TopWinners: 'TOP_WINNERS',
  History: 'HISTORY',
  Result: 'RESULT',
  LiveBets: 'LIVE_BETS',
  Statistics: 'STATISTICS',
  About: 'ABOUT',
  KEY: 'KEY',
  BetTypes: 'BET_TYPES',
  SALT: 'SALT',
  PROVABLY_FAIRNESS: 'PROVABLY_FAIRNESS',
  GAME: 'GAME',
  Soon: 'SOON',
  GO: 'GO',
  Me: 'ME',
  Bet: 'BET',
  Odd: 'ODD',
  Payout: 'PAYOUT',
  Play: 'PLAY',
  PlayForReal: 'PLAY_FOR_REAL',
  FreeBet: 'FREE_BET',
  Bet_1: 'BET_1',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  Rtp: 'RTP',
};

export const globalTranslationKeys = Object.assign(CoreTranslations, TranslationKeys);
